import api from '@/lib/api';

/**
 * Auth API service — used by feature hooks, not components directly.
 */
export const authService = {
  async login(payload) {
    const { data } = await api.post('/auth/login', payload);
    return data.data;
  },

  async logout() {
    await api.post('/auth/logout');
  },

  async me() {
    const { data } = await api.get('/auth/me');
    return data.data;
  },

  async forgotPassword(payload) {
    const { data } = await api.post('/auth/forgot-password', payload);
    return data.data;
  },

  async resetPassword(payload) {
    const { data } = await api.post('/auth/reset-password', payload);
    return data.data;
  },
};
